<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="hub/province/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { Province } from '@/modules/hub/data/province/create'
	import { ProvinceService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return Province;
			},

			service()
			{
				return new ProvinceService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>